// push notification `data` payload (backend contract, not generated).
export type PushNotificationData = Partial<{
  title: string;
  body: string;
  image: string;
  reporting_url: string;
  tenant_code: string;
  reference: string;
  redirect_url: string;
}>;

// delivery/interaction events the frontend reports to the messaging reporting endpoint.
// Backend stores the value as a free-form string; the union keeps the FE call sites in sync
export type PushDeliveryEventType = "received_foreground" | "received_background" | "clicked" | "opened";
